import React from 'react';
import { X, TrendingUp, Users, ShoppingBag, DollarSign, Calculator } from 'lucide-react';
import { Card } from '../../../shared/components/ui/Card';

interface PotentialValueModalProps {
    onClose: () => void;
}

const PotentialValueModal = ({ onClose }: PotentialValueModalProps) => {
    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm animate-fade-in p-4">
            <div role="dialog" aria-modal="true" aria-label="Valor potencial de la base de datos" className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl relative flex flex-col max-h-[90vh] animate-scale-in overflow-hidden">
                {/* Header */}
                <div className="p-6 border-b border-slate-100 bg-white flex justify-between items-center bg-gradient-to-r from-violet-50 to-white">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-violet-100 rounded-xl text-violet-600">
                            <TrendingUp size={24} />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-slate-900">Valor Potencial de Base de Datos</h2>
                            <p className="text-sm text-slate-500">Desglose del cálculo estratégico</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-slate-100 rounded-full text-slate-400 hover:text-slate-900 transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto p-6 space-y-8 custom-scrollbar">

                    <div className="p-4 bg-blue-50/50 rounded-2xl border border-blue-100 text-blue-800 text-sm leading-relaxed">
                        <strong>¿Qué es este número?</strong><br />
                        Es una proyección financiera de cuánto podría facturar tu negocio si se aplicaran estrategias automáticas de marketing sobre tu base de datos actual.
                    </div>

                    <div className="space-y-6">
                        <h3 className="text-sm uppercase tracking-wider font-bold text-slate-500 flex items-center gap-2">
                            <Calculator size={16} />
                            Fórmula de Crecimiento
                        </h3>

                        {/* Vector 1: Reactivacion */}
                        <div className="flex gap-4 p-4 rounded-2xl border border-slate-100 hover:border-violet-200 transition-colors group">
                            <div className="p-3 bg-slate-50 rounded-xl h-fit group-hover:bg-violet-50 text-slate-400 group-hover:text-violet-600 transition-colors">
                                <Users size={24} />
                            </div>
                            <div>
                                <h4 className="font-bold text-slate-900 mb-1">1. Vector Reactivación (+15%)</h4>
                                <p className="text-sm text-slate-600 mb-2">
                                    Recuperación de clientes "dormidos" o inactivos.
                                </p>
                                <div className="text-xs bg-slate-50 inline-block px-3 py-1.5 rounded-lg border border-slate-200 text-slate-500 font-mono">
                                    (Usuarios Inactivos × 15%) × Promedio LTV Global
                                </div>
                            </div>
                        </div>

                        {/* Vector 2: Frecuencia */}
                        <div className="flex gap-4 p-4 rounded-2xl border border-slate-100 hover:border-green-200 transition-colors group">
                            <div className="p-3 bg-slate-50 rounded-xl h-fit group-hover:bg-green-50 text-slate-400 group-hover:text-green-600 transition-colors">
                                <ShoppingBag size={24} />
                            </div>
                            <div>
                                <h4 className="font-bold text-slate-900 mb-1">2. Vector Frecuencia (+20%)</h4>
                                <p className="text-sm text-slate-600 mb-2">
                                    Estrategias de fidelización para que clientes actuales visiten más veces.
                                </p>
                                <div className="text-xs bg-slate-50 inline-block px-3 py-1.5 rounded-lg border border-slate-200 text-slate-500 font-mono">
                                    Usuarios Activos × (LTV Promedio × 20%)
                                </div>
                            </div>
                        </div>

                        {/* Vector 3: Ticket */}
                        <div className="flex gap-4 p-4 rounded-2xl border border-slate-100 hover:border-amber-200 transition-colors group">
                            <div className="p-3 bg-slate-50 rounded-xl h-fit group-hover:bg-amber-50 text-slate-400 group-hover:text-amber-600 transition-colors">
                                <DollarSign size={24} />
                            </div>
                            <div>
                                <h4 className="font-bold text-slate-900 mb-1">3. Vector Ticket Promedio (+10%)</h4>
                                <p className="text-sm text-slate-600 mb-2">
                                    Upselling y Cross-selling para aumentar el valor de cada pedido.
                                </p>
                                <div className="text-xs bg-slate-50 inline-block px-3 py-1.5 rounded-lg border border-slate-200 text-slate-500 font-mono">
                                    Usuarios Activos × (LTV Promedio × 10%)
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center pt-4 border-t border-slate-100">
                        <p className="text-slate-400 text-xs">
                            * Cálculos basados en benchmarks de la industria gastronómica y retail (2026).
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PotentialValueModal;
